export class StringTool {
	static padZero(input: any, targetLength: number) {

		var str = String(input);

		while (str.length < targetLength) {
			str = '0' + str;
		}
		return str;
	}



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/tools/string-tool.ts